export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const GET_MY_PERSONAL_INFO = 'GET_MY_PERSONAL_INFO';
export const POST_PERSONAL_INFO = 'POST_PERSONAL_INFO';
export const GET_PERSONAL_INFO = 'GET_PERSONAL_INFO';
export const PERSONAL_INFO_ERROR = 'PERSONAL_INFO_ERROR';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const USER_INFO_ERROR = 'USER_INFO_ERROR';
export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
export const GET_POSTS_ERROR = 'GET_POSTS_ERROR';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';
export const ADD_POST_ERROR = 'ADD_POST_ERROR';
export const GET_USER_AVATAR_SUCCESS = 'GET_USER_AVATAR_SUCCESS';
export const GET_USER_AVATAR_ERROR = 'GET_USER_AVATAR_ERROR';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';
export const CONNECT_REQUEST_SENT = 'CONNECT_REQUEST_SENT';
export const CONNECT_REQUEST_ERROR = 'CONNECT_REQUEST_ERROR';
export const CONNECT_REQUEST_STATUS_SUCCESS = 'CONNECT_REQUEST_STATUS_SUCCESS';
export const CONNECT_REQUEST_STATUS_ERROR = 'CONNECT_REQUEST_STATUS_ERROR';
export const GET_MY_REQUESTS_SUCCESS = 'GET_MY_REQUESTS_SUCCESS';
export const GET_MY_REQUESTS_ERROR = 'GET_MY_REQUESTS_ERROR';
export const ACCEPT_REQUEST_SUCCESS = 'ACCEPT_REQUEST_SUCCESS';
export const ACCEPT_REQUEST_ERROR = 'ACCEPT_REQUEST_ERROR';
export const GET_CONNECTED_USERS_SUCCESS = 'GET_CONNECTED_USERS_SUCCESS';
export const GET_CONNECTED_USERS_ERROR = 'GET_CONNECTED_USERS_ERROR';
export const LIKE_POST_SUCCESS = 'LIKE_POST_SUCCESS';
export const LIKE_POST_ERROR = 'LIKE_POST_ERROR';
export const GET_POST_LIKED_SUCCESS = 'GET_POST_LIKED_SUCCESS';
export const GET_POST_LIKED_ERROR = 'GET_POST_LIKED_ERROR';
export const GET_LIKES_SUCCESS = 'GET_LIKES_SUCCESS';
export const GET_LIKES_ERROR = 'GET_LIKES_ERROR';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR';
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS';
export const POST_COMMENT_ERROR = 'POST_COMMENT_ERROR';
export const GET_REACTIONS_SUCCESS = 'GET_REACTIONS_SUCCESS';
export const GET_REACTIONS_ERROR = 'GET_REACTIONS_ERROR';
export const READ_REACTION_SUCCESS = 'READ_REACTION_SUCCESS';
export const READ_REACTION_ERROR = 'READ_REACTION_ERROR';
export const GET_FRIENDS_SUCCESS = 'GET_FRIENDS_SUCCESS';
export const GET_FRIENDS_ERROR = 'GET_FRIENDS_ERROR';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const GET_JOBS_ERROR = 'GET_JOBS_ERROR';
export const APPLY_FOR_JOB_SUCCESS = 'APPLY_FOR_JOB_SUCCESS';
export const APPLY_FOR_JOB_ERROR = 'APPLY_FOR_JOB_ERROR';
export const CHECK_JOB_APPLY = 'CHECK_JOB_APPLY';
export const CHECK_APPLIED_STATUS_SUCCESS = 'CHECK_APPLIED_STATUS_SUCCESS';
export const CHECK_APPLIED_STATUS_ERROR = 'CHECK_APPLIED_STATUS_ERROR';
export const ADD_JOB_POST_SUCCESS = 'ADD_JOB_POST_SUCCESS';
export const ADD_JOB_POST_ERROR = 'ADD_JOB_POST_ERROR';
export const GET_APPLICANTS_SUCCESS = 'GET_APPLICANTS_SUCCESS';
export const GET_APPLICANTS_ERROR = 'GET_APPLICANTS_ERROR';
export const SELECT_APPLICANT_SUCCESS = 'SELECT_APPLICANT_SUCCESS';
export const SELECT_APPLICANT_ERROR = 'SELECT_APPLICANT_ERROR';
export const NEW_CHAT_SUCCESS = 'NEW_CHAT_SUCCESS';
export const NEW_CHAT_ERROR = 'NEW_CHAT_ERROR';
export const GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS';
export const GET_CHAT_ERROR = 'GET_CHAT_ERROR';
export const ADD_NEW_MESSAGE_SUCCESS = 'ADD_NEW_MESSAGE_SUCCESS';
export const ADD_NEW_MESSAGE_ERROR = 'ADD_NEW_MESSAGE_ERROR';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_ERROR = 'GET_MESSAGES_ERROR';
export const GET_USER_AVATAR_IN_STATE = 'GET_USER_AVATAR_IN_STATE';
export const RESET_CHAT_MESSAGES = 'RESET_CHAT_MESSAGES';
